module.exports = __webpack_public_path__ + "img/Virgo.cc88f67a.png";